import script from "./AcademyArticleRealtime2.vue?vue&type=script&setup=true&lang=js"
export * from "./AcademyArticleRealtime2.vue?vue&type=script&setup=true&lang=js"

import "./AcademyArticleRealtime2.vue?vue&type=style&index=0&id=274721c8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-274721c8"]])

export default __exports__